import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faBars, faXmark, faPhone, faEnvelope, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";


export default function Navbar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden"; // Disable scroll
    } else {
      document.body.style.overflow = "auto"; // Enable scroll
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup
    };
  }, [open]);


  const leftLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
  ];

  const rightLinks = [
    { name: "Portfolio", path: "/portfolio" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <nav className=" fixed top-0 h-100 w-full bg-[#F8EDE3] text-[#3f2603] shadow-lg z-50 md:py-3 py-3 ">
      <div className="max-w-7xl mx-auto flex items-center justify-between h-16 px-6">

        {/* LEFT NAV LINKS */}
        <div className="hidden md:flex items-center gap-8 text-lg">
          {leftLinks.map((link) => (
            <NavLink
              key={link.name}
              to={link.path}
              className={({ isActive }) =>
                `relative font-bold group ${isActive ? "after:w-full  text-[#3f2603]" : "after:w-0  text-[#855109]"
                } after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:bg-[#855109] after:transition-all after:duration-300 hover:opacity-100 `
              }
            >
              {link.name}
            </NavLink>
          ))}
        </div>


        {/* LOGO CENTER */}
        <Link to="/" className="text-center">
          <img src="/images/logo/apnawebxlogo.png" loading="lazy" alt="ApnaWebX" className="h-16 mx-auto w-auto" />
        </Link>

        {/* RIGHT NAV LINKS */}
        <div className="hidden md:flex items-center gap-8 text-lg">
          {rightLinks.map((link) => (
            <NavLink
              key={link.name}
              to={link.path}
              className={({ isActive }) =>
                `relative font-bold group ${isActive ? "after:w-full text-[#3f2603]" : "after:w-0 text-[#855109]"
                } after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:bg-[#855109] after:transition-all after:duration-300 hover:opacity-100`
              }
            >
              {link.name}
            </NavLink>
          ))}



          {/* Address */}
          <div className="flex items-center gap-2 text-sm">
            <FontAwesomeIcon icon={faLocationDot} className="text-yellow-300 icon" />
          </div>
        </div>

        <div className="flex gap-2 md:hidden">

          <hr />

          {/* MOBILE MENU BUTTON */}
          <button
            className="text-2xl"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            <FontAwesomeIcon
              className="icon"
              icon={open ? faXmark : faBars}
            />
          </button>


          <a
            href="tel:+919998488480"
            className="md:hidden"
            aria-label="Call us at +91 99984 88480"
          >
            <FontAwesomeIcon icon={faPhone} className="icon" />
          </a>

        </div>
      </div>

      {/* MOBILE MENU */}
      {
        open && (
          <div className="md:hidden bg-white text-[#font-extrabold] shadow-lg absolute top-[5.5rem] w-full space-y-4 animate-slideDown">

            {open && (
              <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"></div>
            )}

            <motion.div
              initial={{ x: 300 }}
              animate={{ x: open ? 0 : 300 }}
              transition={{ duration: 0.3 }}
              className="fixed top-[-18px] right-0 w-80 h-full
             bg-white/50 backdrop-blur-xl 
             border-l border-white/30 
             shadow-2xl p-6 md:hidden z-50
"
            >

              <div className="mb-4">
                {/* LOGO CENTER */}
                <Link to="/" className="text-center relative">
                  <img src="/images/logo/apnawebxlogo.png" loading="lazy" alt="ApnaWebX" className="h-20 mx-auto w-auto " />
                </Link>

                <button onClick={() => setOpen(false)} className="absolute top-4 right-4 mb-6 text-2xl">
                  ❌
                </button>
              </div>

              {[...leftLinks, ...rightLinks].map((link) => (
                <NavLink
                  key={link.name}
                  to={link.path}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `relative flex items-center gap-3 text-lg font-semibold 
         py-2 px-3 rounded-lg transition-all duration-300 text-[#855109] 
         ${isActive ? "bg-[#855109]/20 opacity-100" : "opacity-70"}
         hover:bg-white/20 hover:border hover:border-white/30`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        className={`text-[#855109] transition-all duration-300 ${isActive ? "opacity-100" : "opacity-70"
                          }`}
                      />
                      {link.name}
                    </>
                  )}
                </NavLink>
              ))}

              <hr className="mt-4" />

              <div className="flex flex-col items-start mt-5 gap-5 text-lg font-semibold">
                <a href="https://maps.app.goo.gl/Wi5AzdjPKAa4UGW8A" target="_blank" rel="noreferrer" className="flex gap-2 items-center"> <FontAwesomeIcon icon={faLocationDot} className="icon2" /> Ahmedabad, India</a>

                <a href="tel:+919998488480" className="flex gap-2 items-center"> <FontAwesomeIcon icon={faPhone} className=" icon2" /> +91 99984 88480 </a>

                <a href="mailto:support@apnawebx.com" className="flex gap-2 items-center"> <FontAwesomeIcon icon={faEnvelope} className=" icon2" /> support@apnawebx.com </a>
              </div>
            </motion.div>






          </div>
        )
      }
    </nav >
  );
}
